import { put, takeEvery } from 'redux-saga/effects';
import {
  ICreateUserRequestBody,
  IEditUserRequestBody,
  IUserManagementObject,
} from '../../models/UserManagementModel';
import userManagementService from '../../services/UserManagementService/UserManagementService';
import {
  UserManagementAction,
  UserManagementActions,
  UserManagementActionTypes,
} from '../actions/UserManagementActions';
import { ToastActions } from '../actions/ToastActions';
import { NotificationTypes } from '../../../components/notifications/Toast/ToastConstants';

export function* createUserWorker(action: UserManagementAction) {
  try {
    const data = action.data as ICreateUserRequestBody;
    const response: string = (yield userManagementService.createUser(data))!;
    yield put(UserManagementActions.createUserSuccess());
    yield put(
      ToastActions.showToast({
        description: 'Create User Successful',
        type: NotificationTypes.SUCCESS,
      }),
    );
    yield put(UserManagementActions.getUserStart());
  } catch (error) {
    if (error instanceof Error) {
      yield put(UserManagementActions.createUserError(error));
      yield put(
        ToastActions.showToast({
          description: `Create User Failed with ${error}`,
          type: NotificationTypes.ERROR,
        }),
      );
    }
  }
}

export function* getUserWorker(action: UserManagementAction) {
  try {
    const response: IUserManagementObject[] = (yield userManagementService.getUser())!;
    const updatedResponse: IUserManagementObject[] = response.map((data) => ({
      ...data,
      userId: data.UserId || '',
    }));
    yield put(UserManagementActions.getUserSuccess(updatedResponse));
  } catch (error) {
    if (error instanceof Error) {
      yield put(UserManagementActions.getUserError(error));
    }
  }
}

export function* updateUserWorker(action: UserManagementAction) {
  try {
    const data = action.data as IEditUserRequestBody;
    const response: IUserManagementObject[] = (yield userManagementService.updateUser(data))!;
    yield put(UserManagementActions.editUserSuccess());
    yield put(
      ToastActions.showToast({
        description: 'Update User Successful',
        type: NotificationTypes.SUCCESS,
      }),
    );
    yield put(UserManagementActions.getUserStart());
  } catch (error) {
    if (error instanceof Error) {
      yield put(UserManagementActions.editUserError(error));
      yield put(
        ToastActions.showToast({
          description: `Create User Failed with ${error}`,
          type: NotificationTypes.ERROR,
        }),
      );
    }
  }
}

export function* userManagementWatcher() {
  yield takeEvery(UserManagementActionTypes.CREATE_USER_STARTED, createUserWorker);
  yield takeEvery(UserManagementActionTypes.GET_USER_MANAGEMENT_STARTED, getUserWorker);
  yield takeEvery(UserManagementActionTypes.UPDATE_USER_MANAGEMENT_STARTED, updateUserWorker);
}
